import { render, staticRenderFns } from "./file_send.vue?vue&type=template&id=b77d1ac4&scoped=true&"
import script from "./file_send.vue?vue&type=script&lang=js&"
export * from "./file_send.vue?vue&type=script&lang=js&"
import style0 from "./file_send.vue?vue&type=style&index=0&id=b77d1ac4&scoped=true&lang=less&"
import style1 from "./file_send.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77d1ac4",
  null
  
)

export default component.exports